import { atom } from 'recoil';

import { LOCALE } from './translations.model';

export const selectedLocaleState = atom<LOCALE>({
  key: 'selectedLocaleState',
  default: (localStorage.getItem('locale') as LOCALE) || LOCALE.GB,
});
